var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "faq-section-container" },
    [
      _c("page-content-creator", {
        staticClass: "faq-list-header",
        attrs: {
          itemid: "wine-faq-list-header",
          pos: "top",
          name: "wine-faq-list-header",
          "allowed-widgets": "carousel, vimeo-video",
        },
      }),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("page-content-creator", {
                    attrs: { itemid: "wine-faqs-list", pos: "top" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "faq-section" },
            [_c("b-col", [_c("faq-list", { attrs: { faqs: _vm.faqs } })], 1)],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("page-content-creator", {
                    attrs: { itemid: "wine-faqs-list", pos: "bottom" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }